// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var DropDown$ReactHooksTemplate = require("./DropDown.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var QuestionTextPreview$ReactHooksTemplate = require("./QuestionTextPreview.res.js");

function DropDownPreview(props) {
  var onChange = props.onChange;
  var language = props.language;
  var dropDown = props.dropDown;
  var languageName = SurveyLanguage$ReactHooksTemplate.name(language);
  var chooseAnOptionLabel = SurveyLanguage$ReactHooksTemplate.message(language, "choose_an_option");
  var handleOnChange = function ($$event) {
    var choiceId = $$event.target.value;
    if (choiceId === DropDown$ReactHooksTemplate.placeholderOptionValue) {
      return Curry._1(onChange, DropDown$ReactHooksTemplate.clearAnswer(dropDown));
    }
    var selectedChoice = List.find((function (x) {
            return RandomId$ReactHooksTemplate.toString(DropDown$ReactHooksTemplate.choiceId(x)) === choiceId;
          }), DropDown$ReactHooksTemplate.choices(dropDown));
    Curry._1(onChange, DropDown$ReactHooksTemplate.setAnswer(dropDown, selectedChoice));
  };
  var matchChoicesWithAnswer = function (choice) {
    var xs = DropDown$ReactHooksTemplate.getAnswer(dropDown);
    if (xs !== undefined) {
      return Belt_List.has(xs, choice, (function (xs, ys) {
                    return Caml_obj.equal(DropDown$ReactHooksTemplate.choiceId(xs), DropDown$ReactHooksTemplate.choiceId(ys));
                  }));
    } else {
      return false;
    }
  };
  var onTitleChange = function (html) {
    Curry._1(onChange, DropDown$ReactHooksTemplate.setText(dropDown, html));
  };
  var onDescriptionChange = function (html) {
    Curry._1(onChange, DropDown$ReactHooksTemplate.setDescription(dropDown, html));
  };
  var match = DropDown$ReactHooksTemplate.getAnswer(dropDown);
  var answer = DropDown$ReactHooksTemplate.getAnswer(dropDown);
  var tmp;
  if (answer !== undefined) {
    var choice = Belt_List.head(answer);
    tmp = choice !== undefined ? RandomId$ReactHooksTemplate.toString(DropDown$ReactHooksTemplate.choiceId(choice)) : DropDown$ReactHooksTemplate.placeholderOptionValue;
  } else {
    tmp = DropDown$ReactHooksTemplate.placeholderOptionValue;
  }
  var answer$1 = DropDown$ReactHooksTemplate.getAnswer(dropDown);
  var tmp$1;
  if (answer$1 !== undefined) {
    var choice$1 = Belt_List.head(answer$1);
    tmp$1 = choice$1 !== undefined && matchChoicesWithAnswer(choice$1) && DropDown$ReactHooksTemplate.getAllowNonSpecifiedText(choice$1) ? JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("input", {
                  className: "h-48-px py-2 px-4 bg-alicebluepurple border-b border-gray-500 focus:border-gray-600 text-xs w-full",
                  placeholder: "Specify if others",
                  type: "text",
                  onChange: (function (param) {
                      return Curry._1(onChange, DropDown$ReactHooksTemplate.setNotSpecifiedTextForAnswer(dropDown, DropDown$ReactHooksTemplate.setNotSpecifiedText(Utils$ReactHooksTemplate.formTargetValue(param), choice$1)));
                    })
                })
          }) : JsxRuntime.jsx(JsxRuntime.Fragment, {});
  } else {
    tmp$1 = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(QuestionTextPreview$ReactHooksTemplate.make, {
                      text: DropDown$ReactHooksTemplate.getTextTranslation(dropDown, languageName),
                      description: DropDown$ReactHooksTemplate.getDescriptionTranslation(dropDown, languageName),
                      onTitleChange: onTitleChange,
                      onDescriptionChange: onDescriptionChange
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: "Dropdown",
                                      className: "text-aurometalsaurus text-sm mb-2 font-normal"
                                    }),
                                JsxRuntime.jsxs("select", {
                                      children: [
                                        match !== undefined ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx("option", {
                                                children: chooseAnOptionLabel,
                                                value: DropDown$ReactHooksTemplate.placeholderOptionValue
                                              }, "0"),
                                        $$Array.of_list(Belt_List.map(DropDown$ReactHooksTemplate.nonEmptyChoices(dropDown), (function (choice) {
                                                    return JsxRuntime.jsx("option", {
                                                                children: DropDown$ReactHooksTemplate.getChoiceTextTranslation(dropDown, choice, languageName),
                                                                value: RandomId$ReactHooksTemplate.toString(DropDown$ReactHooksTemplate.choiceId(choice))
                                                              }, RandomId$ReactHooksTemplate.toString(DropDown$ReactHooksTemplate.choiceId(choice)));
                                                  })))
                                      ],
                                      className: "block border px-3 py-2 border-gray-400\n                  w-2/5 bg-white rounded capitalize mr-6 text-sm cursor-pointer",
                                      value: tmp,
                                      onChange: handleOnChange
                                    })
                              ],
                              className: "mb-2"
                            }),
                        tmp$1
                      ],
                      className: "flex flex-col"
                    }),
                props.mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "w-full p-16"
            });
}

var make = DropDownPreview;

exports.make = make;
/* react/jsx-runtime Not a pure module */
